<template>
    <a-layout-content>
      <a-spin :spinning="loading.page">
        <a-row :gutter="[16,16]">
          <a-col :xs="24" :lg="16">
            <a-card class="manifest-card" style="height: 100%;">
              <div slot="title">
                  <span class="d-block">Manifest Rekap Klaim Kesehatan Dokter</span>
              </div>
              <div slot="extra" trigger="focus" placement="bottomRight">
                <a-button icon="download" :loading="loading.export" id="buttonAksi" type="primary" @click="exportExcel">Download</a-button>
              </div>
  
              <ul class="list-wrapper bordered">
                <li>
                  <span class="list-title" for>Nomor Rekap</span>
                  <span class="list-desc">{{ manifest_hdr ? manifest_hdr.no_rekap : '' }}</span>
                </li>
                <li>
                  <span class="list-title" for>Tanggal / TLC Pembuat</span>
                  <span class="list-desc">{{ manifest_hdr ? `${moment(manifest_hdr.create_dt).format('DD-M-YYYY')} / ${manifest_hdr.tlc_create}`  : '' }}</span>
                </li>
                <li>
                  <span class="list-title" for>Periode</span>
                  <span class="list-desc">{{ manifest_hdr ? formatPeriode(manifest_hdr.periode) : '' }}</span>
                </li>
                <li>
                  <span class="list-title" for>Catatan</span>
                  <span class="list-desc">{{ manifest_hdr ? manifest_hdr.description : '' }}</span>
                </li>
              </ul>
            </a-card>
  
            <a-card class="manifest-card" style="height: 100%; margin-top: 1rem;">
              <div slot="title">
                  <div style="display: flex; justify-content: space-between;">
                    <span class="d-block">Detail Klaim Kesehatan</span>
                    <a-input-search placeholder="input search TLC" style="width: 200px" @change="onSearchDetail" />
                  </div>
              </div>
  
              <a-table
                :rowKey="(record, index) => { return index.toString(); }"
                size="small"
                bordered
                :scroll="{ x: 850 }"
                :columns="columnsView"
                :dataSource="manifest_detail"
                :pagination="pagination"
                :rowClassName="(record, index) => { return record.check == true ? 'selectedRow' : '' }"
              >
                <template slot="nomor" slot-scope="text,item,index">{{index+1}}</template>
                <template slot="no_klaim" slot-scope="item">{{ item.no_klaim }}</template>
                <template slot="create_date_and_tlc" slot-scope="item">
                    <div style="display: flex; flex-direction: column;">
                        <span>{{ dateFormat(item.tgl_buat_klaim) }}</span>
                        <span>{{ item.tlc_buat_klaim }}</span>
                    </div>
                </template>
                <template slot="anggota" slot-scope="item">{{ item.nama_anggota }}</template>
                <template slot="total_klaim" slot-scope="item">{{ formatRupiah(item.total_klaim) }}</template>
                <template slot="total_approve" slot-scope="item">{{ formatRupiah(item.total_nilai_klaim_appr) }}</template>
                <template slot="action" slot-scope="item">
                  <div class="action-section">
                    <a-button icon="eye" size="small" type="primary" @click="toManifestKlaimKesehatan(item.id_klaim_kesehatan)"></a-button>
                  </div>
                </template>
              </a-table>
              
            </a-card>
  
            <a-card v-if="isAction && getAuth.divisi[0] == 'HRD'" class="manifest-card" style="height: 100%; margin-top: 1rem;">
              <div slot="title">
                  <span class="d-block">Approval Manifest</span>
              </div>
              
              <a-form-model ref="form" :model="formAction" :rules="rules">
                <a-form-model-item label="Aksi" prop="status">
                  <a-select v-model="formAction.status">
                  <a-select-option v-for="c in action_cta" :key="c.aksi" :value="c.aksi">{{c.aksi}}</a-select-option>
                  </a-select>
                </a-form-model-item>
                <a-form-model-item label="Catatan" prop="note">
                  <a-textarea
                    placeholder="Ketik catatan disini ... "
                    :rows="4"
                    v-model="formAction.note"
                  />
                </a-form-model-item>
              </a-form-model>
              
              <a-button 
              style="margin-top: 1rem;"
              :loading="loading.submit" 
              icon="save" type="primary" class="w-full" 
              @click="submitApproval">Submit</a-button>
  
            </a-card>
          </a-col>
  
          <a-col :xs="24" :lg="8">
            <a-collapse activeKey="1" forceRender style="height: 100%;">
              <a-collapse-panel key="1">
                <!-- header panel -->
                <div class="d-flex justify-between align-middle" slot="header">
                  <h4 class="margin-remove">Status</h4>
                  <div>
                    <H-Status v-if="manifest_hdr.status" :status="manifest_hdr.status" />
                    <!-- <a-tooltip placement="topRight">
                      <a-button @click="e => { e.stopPropagation(); showHistory(); }" type="default" size="small" >
                        <a-icon type="history" />
                      </a-button>
                    </a-tooltip> -->
                  </div>
                </div>
                <!-- content -->
                <a-timeline class="m-timeline">
                  <a-timeline-item v-for="sts in manifest_status" color="grey" :key="sts.id_status">
                    <div class="m-timeline-title">{{ sts.actor }} - {{sts.tlc}}</div>
                    <div class="m-timeline-body">
                      <h4 class="margin-remove">{{sts.tanggal_aksi}}</h4>
                      <span class="m-text-small" v-if="sts.remark">{{sts.remark}}</span>
                      <span class="m-text-small" v-else>Tidak Ada Catatan</span>
                    </div>
                    <div class="m-timeline-footer">
                      <a-tag :color="severity(sts.status)">{{sts.status}}</a-tag>
                    </div>
                  </a-timeline-item>
                </a-timeline>
              </a-collapse-panel>
            </a-collapse>
          </a-col>
  
        </a-row>
      </a-spin>
  
      <a-modal v-model="history_visible" :footer="null">
        <span slot="title">
          <a-icon type="history" />&nbsp;History Status
        </span>
  
        <ul class="list-wrapper bordered">
          <li v-for="history in history" :key="history.id_notifikasi">
            <div v-if="history.aksi === '1' || history.aksi === '3'">
              <div class="d-flex justify-between">
                <h3 class="m-remove list-title">{{ history.as_from }} | {{ history.tlc_from }}</h3>
                <H-Status :status="history.deskripsi" />
              </div>
              <span class="m-list-desc">{{ history.tgl_notif }}</span>
            </div>
            <div v-else-if="history.aksi === '2' || history.aksi === '4'">
              <div class="d-flex justify-between">
                <h3 class="m-remove list-title"
                  v-if="(history.aksi === '4' && history.deskripsi === 'Edited') || history.deskripsi === 'Revised'">
                  {{ history.as_from }} | {{ history.tlc_from }}</h3>
                <h3 class="m-remove list-title" v-else>{{ history.as_to }} | {{ history.tlc_to }}</h3>
                <H-Status :status="history.deskripsi" />
              </div>
              <span class="list-desc">{{ history.tgl_notif }}</span>
            </div>
          </li>
        </ul>
      </a-modal>
  
    </a-layout-content>
  </template>
  
  <script>
  import moment from "moment-business-days"
  import Status from "@/components/Status.vue";
  import CurrencyFormat from "@/mixins/CurrencyFormat";
  import { mapGetters } from "vuex";
  
  const columns = [
    {
      title: "#",
      key: "nomor",
      align: "center",
      scopedSlots: { customRender: "nomor" },
      width: 50,
    },
    {
      title: "Create date / TLC",
      key: "create_dt",
      align: "center",
      scopedSlots: { customRender: "create_dt" },
      width: 150,
    },
    {
      title: "No. Realisasi SPL",
      key: "no_realisasi_spl",
      align: "center",
      scopedSlots: { customRender: "no_realisasi_spl" },
      width: 200,
    },
    {
      title: "Unit Kerja",
      key: "divisi",
      align: "center",
      scopedSlots: { customRender: "divisi" },
      width: 100,
    },
    {
      title: "Pelaksana",
      key: "tlc_pelaksana",
      align: "center",
      scopedSlots: { customRender: "tlc_pelaksana" },
      width: 150,
    },
    {
      title: "Nilai Tarif",
      key: "total_tarip",
      align: "center",
      scopedSlots: { customRender: "total_tarip" },
    },
    {
      title: "Aksi",
      align: "center",
      scopedSlots: { customRender: "action" },
      width: 100,
    },
  ]
  
  const rules = {
    status: {
      required: true,
      message: "Harap isi aksi!",
      trigger: ["blur", "change"],
    },
    note: {
      required: true,
      message: "Harap isi catatan!",
      trigger: ["blur", "change"],
    },
  }
  
  const columnslogHistory = [
    {
      title: "#",
      scopedSlots: { customRender: "no" },
      align: "right",
      width: "35px"
    },
    {
      title: "Log. Absensi",
      dataIndex: "timestamp",
      align: "center",
    },
  ]

  const columnsView = [
    {
      title: "#",
      key: "nomor",
      align: "center",
      scopedSlots: { customRender: "nomor" },
      width: 50,
    },
    {
      title: "No. Klaim",
      key: "no_klaim",
      align: "center",
      scopedSlots: { customRender: "no_klaim" },
      width: 210,
    },
    {
      title: "Tanggal Buat / TLC",
      key: "create_dt",
      align: "center",
      scopedSlots: { customRender: "create_date_and_tlc" },
      width: 100,
    },
    {
      title: "Nama Anggota Keluarga",
      key: "anggota",
      align: "center",
      scopedSlots: { customRender: "anggota" },
      width: 210,
    },
    {
      title: "Total Klaim",
      key: "total_klaim",
      align: "center",
      width: 200,
      scopedSlots: { customRender: "total_klaim" },
    },
    {
      title: "Total Approve",
      key: "total_nilai_klaim_appr",
      align: "center",
      width: 200,
      scopedSlots: { customRender: "total_approve" },
    },
    {
      title: "Aksi",
      align: "center",
      scopedSlots: { customRender: "action" },
      width: 100,
    },
  ]
  
  export default{
    mixins: [CurrencyFormat],
    props: ["id"],
    components: {
      "H-Status": Status
    },
    data(){
      return {
        rules,
        columns,
        columnslogHistory,
        columnsView,
        moment,
        manifest_hdr: [],
        manifest_status: [],
        manifest_detail: [],
        manifest_detail_temp: [],
        pp_combo: [],
        pp_document: [],
        history: [],
        action_cta: [],
        detailData: [],
        history_visible: false,
        update_visible: false,
        loading: {
          page: false,
          submit: false,
          detail: false,
          export: false,
          update: false
        },
        pagination: {},
        formAction: {
          status: null,
          note: ''
        },
        isAction: false,
        labelNo: '',
        modalVisible: false
      }
    },
  
    beforeCreate() {
      this.form = this.$form.createForm(this);
    },
  
    computed: {
      ...mapGetters([
        "getAuth",
        "getDefaultDateFormat",
        "getStandartFormatDate",
      ]),
    },
  
    watch: {
      id(){
        this.fetchManifest()
      }
    },
  
    mounted(){
      this.fetchManifest()
    },
  
    methods: {
      async fetchManifest(){
        try {
          this.loading.page = true
          const payload = {
            id_rekap: this.id
          }
          const response = await this.asyncAxiosGet('rekap_klaim_dokter/manifest', this.getAuth, payload);
          this.manifest_hdr = response.data.hdr
          this.manifest_detail = response.data.detail
          this.manifest_status = response.data.sts
          this.manifest_detail_temp = response.data.detail
        //   this.pp_combo = response.pp_combo
        //   this.pp_document = response.pp_document
        //   this.history = response.history_sts
        //   this.isAction = response.allow_action
        //   this.action_cta = response.action_cta
          console.log(response);
          
          this.loading.page = false
        } catch (error) {
          this.loading.page = false
          console.log(error);
        }
      },
  
      submitApproval(){
        this.loading.submit = true
        this.$refs.form.validate( async (valid) => {
          if(!valid){
            this.loading.submit = false
            return true
          }
  
          try {
            const payload = {
              manifest_id: this.id,
              status: this.formAction.status,
              note: this.formAction.note
            }
            const response = await this.asyncAxiosPost("rekap_realisasi_tarif_spl/approval", "json", this.getAuth, payload)
            this.displayMessageValue("success-basic", "Approval Manifest Success");
            this.fetchManifest()
            this.loading.submit = false
            window.location.reload()
          } catch (error) {
            this.loading.submit = false
            console.log(error);
          }
        })
      },
  
      async fetchDetail(id, tlc){
        this.loading.detail = true
        try {
          const payload = {
            realisasi_spl_id: id,
            pelaksana: tlc
          }
          const response = await this.asyncAxiosGet('rekap_realisasi_tarif_spl/detail_realisasi', this.getAuth, payload);
          this.detailData = response.list
          this.loading.detail = false
          
        } catch (error) {
          this.loading.detail = false
          console.log(error);
        }
      },
  
      dateFormat(date){
        return this.moment(date).format('DD-MM-YYYY');
      },
  
      formatPeriode(val){
        const month = [
          "Januari",
          "Februari",
          "Maret",
          "April",
          "Mei",
          "Juni",
          "Juli",
          "Agustus",
          "September",
          "Oktober",
          "November",
          "Desember"
        ]
  
        if (!val) return "";
  
        const [year, monthNum] = val.split("-");
        const namaBulan = month[parseInt(monthNum, 10) - 1];
  
        return `${namaBulan} ${year}`;
      },
  
      severity(status){
        if(status == 'Delivered'){
          return 'blue'
        }else if(status == 'Revised' || status == 'Rejected'){
          return 'red'
        }else if(status == 'Approved'){
          return 'green'
        }else {
          return 'orange'
        }
      },
  
      showHistory(){
        this.history_visible = true
      },
  
      showModalUpdate(){
        this.update_visible = true
      },
  
      modalCancel(){
        this.update_visible = false
      },
  
      showModalView(data){
        this.modalVisible = true
        this.fetchDetail(data.realisasi_spl_id, data.tlc_pelaksana)
        this.labelNo = data.no_realisasi_spl
      },
  
      modalClose(){
        this.modalVisible = false
      },
  
      realisasijam(start, end) {
        let result = ""
        start = moment(start)
        end = moment(end)
        let durasi = moment.duration(end.diff(start));
        result = durasi.hours() + " jam " + durasi.minutes() + " menit"
        return result
      },
  
      formatDecimal(val) {
        if(Number(val) == 0){
          return 0;
        }else {
          return Number(val).toFixed(4)
        }
      },
  
      async exportExcel(){
        try {
          this.loading.export = true
          const payload = {
            manifest_id: this.id
          }
          const response = await this.asyncAxiosFile('rekap_klaim_dokter/export_manifest', this.getAuth, payload)
  
          const fileName = this.manifest_hdr.no_rekap+'.xlsx';
          const blob = new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          });
          const urlBlob = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = urlBlob;
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
          link.remove();
          this.loading.export = false
          this.displayMessageValue("success-basic", "Export rekap success");
  
          return response;
        } catch (error) {
          this.loading.export = false
          console.log(error);
          this.displayMessageValue("error-basic", "Oops something went wrong");
        }
      },
  
      onSearchDetail(val){      
        if(val){
          this.manifest_detail = this.manifest_detail_temp
  
          this.manifest_detail = this.manifest_detail.filter(
            (obj) =>
              (obj.tlc_buat_klaim ? obj.tlc_buat_klaim : " ")
              .toLowerCase()
              .indexOf(val.target.value.toLowerCase()) >= 0 
          );
        }
      },
  
      filterOption(input, option) {
        return (
          option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
        );
      },
  
      onSubmitPpDoc(){
        this.loading.update = true
        this.form.validateFields( async (err, values) => {
          if(err){
            this.loading.update = false
            return
          }
  
          try {
            const payload = {
              manifest_id: this.id,
              pp_no: values.pp_no
            }
            const response = await this.asyncAxiosPut("rekap_realisasi_tarif_spl/pp_document", "json", this.getAuth, payload)
            if(response){
              this.displayMessageValue("success-basic", "Update PP Document Success");
              this.modalCancel()
              this.fetchManifest()
            }
            this.loading.update = false
          } catch (error) {
            this.loading.update = false
            console.log(error);
          }
        })
      },

      toManifestKlaimKesehatan(id){
        // this.$router.push({ name: "monitoring_klaim_manifest", params: {id: id} })
        const route = this.$router.resolve({
            name: "monitoring_klaim_manifest",
            params: { id: id }
        });

        window.open(route.href, '_blank');
      }
  
    }
  }
  </script>